import { Group, Paper, Skeleton, Stack } from "@mantine/core";

function LoadingTile() {
  return (
    <Paper className="MiniTile" mih={130} miw={250}>
      <Stack h="100%" justify="space-between">
        <Group
          align="center"
          className="mini-tile-header"
          gap="xs"
          justify="space-between"
          wrap="nowrap"
        >
          <Skeleton
            height={
              "calc(var(--mantine-h4-font-size) * var(--mantine-line-height-sm))"
            }
            radius="xl"
            width={100}
          />
        </Group>
        <LoadingLines />
      </Stack>
    </Paper>
  );
}

function LoadingLines() {
  return (
    <Stack gap="xs">
      <Skeleton height={"var(--mantine-font-size-md)"} radius="xl" />
      <Skeleton
        height={
          "calc(var(--mantine-h4-font-size) * var(--mantine-line-height-sm))"
        }
        radius="xl"
      />
    </Stack>
  );
}

export { LoadingLines, LoadingTile };
